/**
 * Safely stringify large objects with size limit to prevent main thread blocking
 */
export function safeStringify(
  value: unknown,
  maxSize = 10 * 1024 * 1024, // 10MB default limit
): string {
  if (typeof value === 'string') {
    // For strings, check length directly
    if (value.length > maxSize) {
      return `[Large string truncated: ${value.length} bytes]\n${value.substring(0, 1000)}...`;
    }
    return value;
  }
  try {
    let stringified = '';
    let truncated = false;

    // Use a replacer to track size during stringification
    const replacer = (key: string, val: unknown) => {
      if (truncated) return '[truncated]';
      const current = JSON.stringify(val);
      if (stringified.length + current.length > maxSize) {
        truncated = true;
        return '[truncated - object too large]';
      }
      return val;
    };

    stringified = JSON.stringify(value, replacer, 2);

    if (truncated) {
      return `[Large object truncated: >${maxSize} bytes]\n${stringified}`;
    }

    return stringified;
  } catch (error) {
    return `[Unable to stringify object: ${error instanceof Error ? error.message : 'unknown error'}]`;
  }
}
